import { render, staticRenderFns } from "./reportfaculty.vue?vue&type=template&id=44a89564&"
import script from "./reportfaculty.vue?vue&type=script&lang=js&"
export * from "./reportfaculty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports